import React from 'react';
import { Link } from 'react-router-dom';
import { User, Building, ArrowRight } from 'lucide-react';
import AuthForm from './AuthForm';
import '../Login.css';

function LoginHome() {
  return (
    <AuthForm title="">
      <div className="login-home-container">
        <p className="login-home-description">
          Accédez à votre espace en toute simplicité
        </p>
        
        <div className="login-options">
          <Link to="/client-login" className="login-option">
            <div className="login-option-icon">
              <Building size={24} />
            </div>
            <div className="login-option-content">
              <h3 className="login-option-title">Espace Bénéficiaire</h3>
              <p className="login-option-description">
                Suivi de rendez-vous et communication
              </p>
            </div>
            <ArrowRight size={18} className="login-option-arrow" />
          </Link>
          
          <Link to="/login" className="login-option">
            <div className="login-option-icon">
              <User size={24} />
            </div>
            <div className="login-option-content">
              <h3 className="login-option-title">Espace Intervenant</h3>
              <p className="login-option-description">
                Gestion de planning et outils professionnels
              </p>
            </div>
            <ArrowRight size={18} className="login-option-arrow" />
          </Link>

          
        </div>

        <div className="login-home-footer">
          <p className="text-sm text-gray-500">
            Une question ? Contactez votre administrateur
          </p>
        </div>
      </div>
    </AuthForm>
  );
}

export default LoginHome;
